import GB from './gb'
import RU from './ru'
import UA from './ua'

const translations = { GB, RU, UA}


export default translations